export default __webpack_public_path__ + "media/images/hot_stuff_16-3c11a1bf7703ab1688dafbb2311d80d8.png";